import React from 'react'
import classNames from 'classnames';
import { saveAs } from 'file-saver'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RestUtilities from '../services/Base';

interface Props {
  asn: any;
  coAFileName: string
  close: () => void  
  uploader:  (selectedFiles: FileList|null) => void
  asnStatus: string
  uploading: boolean
  header: any
  lp: string
  harvestDate: string
  lotCode: string
  sku: any
}

const CoAModalView = (props: Props) => {
  const getCoa = async () => {

    let downloadLink = `/api/lot/${props.lp}/${props.harvestDate}/${props.lotCode.trim()}/${props.sku.trim()}/coa`;

    if (props.asn.qvUpf === "Y" && props.asn.licensedProducer && props.asn.qvCoa !== undefined && (props.asn.qvCoa.trim() === props.coAFileName.trim())) {
      //if asn and lot coa match (hasn't been changed and is uploaded), use asn to ensure old asns still can access CoAs not on lots. Otherwise get from lot
      downloadLink = `/api/asn/${props.asn.licensedProducer}/${props.asn.documentNumber}/${props.asn.lineID}/coa`;
    }

    const response = await RestUtilities.get(downloadLink);
    saveAs(response.content, props.coAFileName.trim());
  }


  return (
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Uploaded Certificate of Analysis</h4>

          <button
            onClick={props.close}
            type="button"
            className={classNames({
              close: true
            })}>
            <span aria-hidden="true">&times;</span>
          </button>

        </div>
        <h5 style={{"padding": "10px 20px"}}>{`Current File: ${props.coAFileName}`}</h5>
        <div className="modal-body">
          <div style={{textAlign:"center", paddingBottom:"30px"}}>
              {!props.uploading && <button className="btn btn-orange" onClick={getCoa}>
                Download CoA
             </button>}
            </div>
            
        </div>
      </div>
    </div>
  );

}

export default CoAModalView;
